<template>
    <div class="video-wrap absolute -z-10 overflow-hidden w-full h-full">
        <video
            :id="videoId"
            ref="video"
            class="tis-video object-cover fixed top-0 left-0 w-full h-full"
            :autoplay="autoplay"
            :poster="videoPosterUrl"
            loop
            muted
            playsinline
            preload
        >
            <source
                :src="videoUrl"
                :type="getMediaType(videoUrl)">
        </video>
    </div>
</template>


<script>


export default {
  name: 'VideoBackground',
  props: {
    videoId: {
      type: String,
      required: false,
      default: '',
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    videoUrl: {
      type: String,
      required: true,
      default: '/videos/TIS-Dashboard-video.mp4',
    },
    videoPosterUrl: {
      type: String,
      default: '/videos/TIS-Dashboard-video.mp4',
    },
  },
  mounted() {
    this.setImageUrl();

    if (this.videoCanPlay()) {
      this.$refs.video.oncanplay = () => {
        if (!this.$refs.video) return;
        this.$refs.video.style.visibility = 'visible';
      };
    }
  },

  methods: {
    videoCanPlay() {
      return !!this.$refs.video.canPlayType;
    },

    setImageUrl() {
      if (this.img) {
        this.$el.style.backgroundImage = `url(${this.img})`;
      }
    },

    getMediaType(src) {
      return `video/${src.split('.').pop()}`;
    },

  },
};
</script>


<style>
    .video-wrap:before {
        content: "";
        width: 200%;
        height: 200%;
        margin: -50px;
        z-index: 1;
        position: absolute;
        top: 0;
        background: url(/img/video-halftone-overlay.png), linear-gradient(to bottom, rgba(0, 0, 0, 0.43) 0%, rgba(0, 0, 0, 0.52) 5%, rgba(0, 0, 0, 0.1) 10%, rgba(0, 0, 0, 0.64) 46%, rgba(0, 0, 0, 0.19) 100%)
    }
</style>
